import _Cached from "@mui/icons-material/Cached";
import React from 'react';
import { COLORS, FONTS } from '@fupa/fupa-uikit';
import ActivityHeader from 'app/components/district/common/ActivityHeader';
import { IconContainer } from 'app/components/district/common/ActivityStyles';
export default function TransferActivityHeader(_ref) {
  let {
    teamName,
    publishDate
  } = _ref;
  return /*#__PURE__*/React.createElement(ActivityHeader, {
    title: "Transfer",
    subject: teamName,
    publishDate: publishDate,
    "data-sentry-element": "ActivityHeader",
    "data-sentry-component": "TransferActivityHeader",
    "data-sentry-source-file": "TransferActivityHeader.tsx"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    color: COLORS.orange,
    "data-sentry-element": "IconContainer",
    "data-sentry-source-file": "TransferActivityHeader.tsx"
  }, /*#__PURE__*/React.createElement(_Cached, {
    sx: {
      fontSize: FONTS['20'],
      color: COLORS.white
    },
    "data-sentry-element": "Cached",
    "data-sentry-source-file": "TransferActivityHeader.tsx"
  })));
}